import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

interface IProps {
  total?: number;
  correct?: number;
  incorrect?: number;
}

const Header = ({ total, correct, incorrect }: IProps) => {
  const t = useTranslations();

  return (
    <div className="z-10 mb-4 flex items-center justify-between rounded-xl bg-white p-4 md:sticky md:top-0">
      <h3>{t('test_natijalari')}</h3>
      <div className="flex items-center justify-between gap-5 rounded-xl">
        <div className="flex w-full flex-col space-y-1 border-gray-300 text-center">
          <div className="flex items-center justify-center gap-1">
            <div className="size-4.5 relative">
              <Image src="/images/total-test-paper.webp" fill alt="Total tests count" title="Umumiy savollar soni" />
            </div>
            <p className="font-medium">{total}</p>
          </div>
        </div>
        <div className="flex w-full flex-col space-y-1 border-gray-300 text-center">
          <div className="flex items-center justify-center gap-1">
            <div className="size-4.5 relative">
              <Image src="/images/correct-answer.webp" fill alt="Correct Answer" title="Tog'ri javob" />
            </div>
            <p className="font-medium">{correct}</p>
          </div>
        </div>
        <div className="flex w-full flex-col space-y-1 text-center">
          <div className="flex items-center justify-center gap-1">
            <div className="size-4.5 relative">
              <Image src="/images/incorrect-answer.webp" fill alt="Incorrect Answer" title="Notog'ri javob" />
            </div>
            <p className="font-medium">{incorrect}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
